import { loader } from "../utils/assetLoader";

const duration = 500;
class ScorePickup {
    constructor(container) {
        this.container = container;


        this.textStyle = new PIXI.TextStyle({
            fontFamily: 'mainFont',
            fontSize: 45,
            fontWeight: '500',
            fill: [
                '#fce61d',
                '#fe5c00'
            ],
            fillGradientStops: [
                0, 0.5
            ],
            // fillGradientType: 180,
        });

        this.anchor = {
            x: -30, y: -25,
        }
    }

    spawnScoreEff(text) {
        let textNode = new PIXI.Text(text, this.textStyle);
        textNode.position.set(this.anchor.x, this.anchor.y);
        this.animateText(textNode);
        this.container.addChild(textNode);
    }

    animateText(textNode) {
        let [startX, startY] = [this.anchor.x, this.anchor.y];
        let endX = -1 * (Math.random() * 10 + 5);
        let endY = -1 * (Math.random() * 5 + 5);
        
        let maxSteps = duration / 5;
        let steps = maxSteps;

        const interval = window.setInterval(() => {
            steps--;
            if (steps > 0) {
                let t = 1 - (steps/maxSteps);
                textNode.alpha -= 1/maxSteps;
                const x = startX + (endX - startX) * -t;
                const y = 4 * t * (t - 1) + startY + (endY - startY) * -t;

                textNode.position.set(x, y);

            } else if (steps === 0) {
                
            } else {
                clearInterval(interval);
                textNode.destroy();
            }
        }, 5);
    }
}

export default ScorePickup;